import { useState, useRef, useEffect } from 'react';
import { ReactComponent as LabBeta } from 'assets/icons/labBeta.svg';
import { ReactComponent as Lab } from 'assets/icons/lab.svg';
import InfoIcon from '@mui/icons-material/Info';
import { styled } from '@mui/material/styles';
import { Box, Popover, Typography, Stack, Divider } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useBeta from 'hook/useBeta';

const ButtonBeta = styled(Box)`
  display: flex;
  align-items: center;
  padding: 6px 7px 6px 6px;
  background: #ffffff;
  border-radius: 8px;
  cursor: pointer;
  --color-text: linear-gradient(135deg, #24772b 0%, #7fbf68 100%);
  ${(props) => {
    if (props.isUsedBeta) {
      return `
        background: ${props.theme.palette.primary.main};
        box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px rgba(0, 0, 0, 0.14), 0px 1px 5px rgba(0, 0, 0, 0.12);
        :hover {
          box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.4), 0px 2px 2px rgba(0, 0, 0, 0.28), 0px 1px 5px rgba(0, 0, 0, 0.14);
        }
        --color-text: #ffffff;
      `;
    } else {
      return `
        :hover {
          box-shadow: inset -1px -2px 2px rgba(0, 0, 0, 0.25);
          box-shadow: inset -2px -3px 2px rgba(0, 0, 0, 0.4);
        }
      `;
    }
  }}
`;
const TypographyBeta = styled(Typography)`
  font-weight: 600;
  font-size: 1rem;
  background: var(--color-text);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;
const LabBetaIcon = styled(LabBeta)`
  font-size: 1.5rem;
`;

const RootPopover = styled(Box)`
  width: 300px;
  padding: 10px;
`;

const Beta = ({onSubmit}) => {
  const { t } = useTranslation();
  const { isUsedBeta, isFristFoundBeta, setIsFristFoundBeta } = useBeta();
  const [ transitionDuration, setTransitionDuration] = useState("auto")
  const [anchorEl, setAnchorEl] = useState(null);
  const popoverRef = useRef(null);

  const handlePopoverOpen = () => {
    !isUsedBeta && setAnchorEl(popoverRef.current)
  };
  const handlePopoverClose = () => {
    setAnchorEl(null)
    setIsFristFoundBeta(false)
    setTransitionDuration("auto")
  };

  const open = Boolean(anchorEl);

  useEffect(() => {
    if(isFristFoundBeta){ 
      setAnchorEl(document.getElementById("box-button-beta"))
      setTransitionDuration(0)
    }
  }, [])
  
  return (
    <>
      <Box ref={popoverRef} onMouseEnter={handlePopoverOpen} onMouseLeave={handlePopoverClose} id="box-button-beta">
        <ButtonBeta isUsedBeta={isUsedBeta} onClick={()=>onSubmit()} >
          {isUsedBeta ? <Lab /> : <LabBetaIcon />}
          <TypographyBeta isUsedBeta={isUsedBeta}>
            {isUsedBeta ? t('beta.back_to_non_beta') : t('beta.beta_test')}
          </TypographyBeta>
        </ButtonBeta>
      </Box>
      <Popover
        id="mouse-over-popover"
        sx={{
          pointerEvents: 'none',
          marginTop: '10px',
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transitionDuration={transitionDuration}
        onClose={handlePopoverClose}
        disableRestoreFocus
        PaperProps={{
          onMouseEnter: handlePopoverOpen,
          onMouseLeave: handlePopoverClose,
          sx: {
            pointerEvents: 'auto',
            borderRadius: '8px',
          },
        }}
      >
        <RootPopover>
          <Stack spacing={'10px'}>
            <Stack direction={'row'} alignItems="center" justifyContent={'center'} spacing={1}>
              <Typography variant="subtitle2" color="primary.main">
                {t("beta.content_popover_goto_beta.title")}
              </Typography>
              <InfoIcon color="warning" />
            </Stack>
            <Typography variant="body3" color="text.secondary" sx={{ whiteSpace: "pre-wrap"}}>
              {t("beta.content_popover_goto_beta.description")}
            </Typography>
            <Divider></Divider>
            <Typography
              variant="subtitle2"
              color="primary.main"
              sx={{ textDecorationLine: 'underline', textAlign: 'end', cursor: 'pointer' }}
              onClick={handlePopoverClose}
            >
              {t("beta.content_popover_goto_beta.close")}
            </Typography>
          </Stack>
        </RootPopover>
      </Popover>
    </>
  );
};

export default Beta;
